module.exports = __webpack_public_path__ + "img/clock-project.d1283449.svg";